import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import React, { Fragment } from "react";
import { ButtonSecondaryModal } from "../atoms/ButtonSecondaryModal";
import { ButtonPrimaryModal } from "../atoms/ButtonPrimaryModal";

export type ModalAcceptSearchTrainingProps = {
  onClick?: () => void;
  onClose: () => void;
  open: boolean;
  acceptButtonText?: string;
  cancelButtonText?: string;
  children?: React.ReactNode;
  title: string;
};

export const ModalAcceptSearchTraining: React.FC<
  ModalAcceptSearchTrainingProps
> = ({
  onClick,
  onClose,
  open,
  acceptButtonText,
  cancelButtonText,
  children,
  title,
}) => (
  <Fragment>
    <Dialog open={open} onClose={onClose} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-md data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 max-h-[50vh] overflow-visible">
              {/* Ajuste del tamaño máximo y scroll si es necesario */}
              <div className="">
                <div className="mt-3 sm:ml-0 sm:mt-0">
                  <div className="flex justify-between items-center">
                    <DialogTitle
                      as="h3"
                      className="text-base font-semibold leading-6 text-gray-900"
                    >
                      {title}
                    </DialogTitle>
                  </div>
                  <div className="mt-2">{children}</div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <Fragment>
                {acceptButtonText === undefined ? (
                  <></>
                ) : (
                  <>
                    <ButtonPrimaryModal
                      text={acceptButtonText}
                      onClick={onClick}
                    />
                  </>
                )}
                {cancelButtonText === undefined ? (
                  <></>
                ) : (
                  <ButtonSecondaryModal
                    text={cancelButtonText}
                    onClick={onClose}
                  />
                )}
              </Fragment>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </Fragment>
);
